const ROSTER_JOIN_SESSION_KEY = "tra_roster_join_session";
const LOBBY_PROFILE_PROMPT_KEY = "tra_lobby_profile_prompt";
const PENDING_ROSTER_ROOM_KEY = "tra_pending_roster_invite_room";

export function writePendingRosterInviteRoom(roomCode) {
  try {
    const code = (roomCode || "").trim();
    if (!code) return;
    sessionStorage.setItem(PENDING_ROSTER_ROOM_KEY, code);
  } catch {
    /* ignore */
  }
}

export function readPendingRosterInviteRoom() {
  try {
    return sessionStorage.getItem(PENDING_ROSTER_ROOM_KEY) || "";
  } catch {
    return "";
  }
}

export function clearPendingRosterInviteRoom() {
  try {
    sessionStorage.removeItem(PENDING_ROSTER_ROOM_KEY);
  } catch {
    /* ignore */
  }
}

export function markRosterJoinSession(active) {
  try {
    if (active) sessionStorage.setItem(ROSTER_JOIN_SESSION_KEY, "1");
    else sessionStorage.removeItem(ROSTER_JOIN_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function readRosterJoinSession() {
  try {
    return sessionStorage.getItem(ROSTER_JOIN_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function writeLobbyProfilePrompt(show) {
  try {
    if (show) sessionStorage.setItem(LOBBY_PROFILE_PROMPT_KEY, "1");
    else sessionStorage.removeItem(LOBBY_PROFILE_PROMPT_KEY);
  } catch {
    /* ignore */
  }
}

export function readLobbyProfilePrompt() {
  try {
    return sessionStorage.getItem(LOBBY_PROFILE_PROMPT_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearLobbyProfilePrompt() {
  writeLobbyProfilePrompt(false);
}
